import React from "react";
import style from "./index.module.scss";
import TableHeadTip from "../../Components/TableHeadTip";
import TableBody from "../../Components/TableBody";
import { filterData, QueryRuleResult } from "../../../../API/scoreRule";
import { Empty, Input, Spin } from "antd";
import AddSc from "../Components/AddSc";
import FileItem from "../../../../components/FileItem";
import config from "../../../../config";
const { TextArea } = Input;

const Index = ({
    scoreInfo,
    loading
}: {
    scoreInfo: QueryRuleResult | null;
    loading: boolean;
}) => {
    return (
        <div className={style.root}>
            <Spin spinning={false}>
                <div
                    className={style.table}
                    style={{
                        display: "inline-block"
                    }}>
                    {scoreInfo?.filePath && (
                        <a
                            href={`${config.QiNiuDownloadUrl}/${scoreInfo.filePath}?attname=${scoreInfo.fileName}`}
                            target="_blank"
                            className={style.label}>
                            <FileItem
                                text={scoreInfo.fileName}
                                fileType={scoreInfo?.fileType || ""}
                            />
                        </a>
                    )}
                </div>
                <div className={style.table}>
                    <TableHeadTip title="考核规则" />
                    <p style={{ padding: 10 }}>{scoreInfo?.description}</p>
                </div>
                <div className={style.table}>
                    <TableHeadTip
                        title="平时成绩"
                        percent={scoreInfo?.dailyGrade || 0}
                    />
                    <TableBody
                        list={filterData(scoreInfo?.dailyGradeRuleModel || [])}
                        ruleCourseName="平时成绩"
                        loading={loading}
                    />
                </div>
                <div className={style.table}>
                    <TableHeadTip
                        title="期末成绩"
                        percent={scoreInfo?.finalGrade || 0}
                    />
                    <TableBody
                        list={filterData(scoreInfo?.finalGradeRuleModel || [])}
                        ruleCourseName="期末成绩"
                        loading={loading}
                    />
                </div>
                <div className={style.table}>
                    <TableHeadTip title="额外加分" />
                    <div style={{ padding: "35px" }}>
                        {!scoreInfo?.extraRule && (
                            <Empty description="此课程未设置额外加分" />
                        )}
                        {scoreInfo?.extraRule && (
                            <AddSc
                                disabled
                                extraRule={scoreInfo.extraRule}
                                expSwitch
                            />
                        )}
                    </div>
                </div>
            </Spin>
        </div>
    );
};

export default Index;
